import ExcelJS from "exceljs";

interface Sheet {
  sheetName: string;
  columns: { header: string; key: string; width?: number }[];
  data: Record<string, any>[];
  styles?: {
    headerBold?: boolean;
    boldRows?: string[];
  };
}

interface ExportOptions {
  filename: string;
  sheets: Sheet[];
}

const createWorksheet = (workbook: ExcelJS.Workbook, { sheetName, columns, data, styles = {} }: Sheet) => {
  const sheet = workbook.addWorksheet(sheetName);
  let startRow = 1;

  if (typeof data[0] === "string") {
    const noteRow = sheet.addRow([data[0]]);
    noteRow.font = { italic: false };
    data.shift();
    startRow++;
  }

  const headerRow = sheet.addRow(columns.map(({ header }) => header));
  if (styles.headerBold) headerRow.font = { bold: true };

  sheet.columns = columns.map(({ key, width = 20 }) => ({ key, width }));

  data.forEach((row) => {
    const rowData = columns.map((col) => row[col.key]);
    const addedRow = sheet.addRow(rowData);

    if (styles.boldRows?.includes(row[columns[0].key])) {
      addedRow.font = { bold: true };
    }
  });
};

const exportToExcel = async ({ filename, sheets }: ExportOptions): Promise<void> => {
  const workbook = new ExcelJS.Workbook();
  sheets.forEach((sheet) => createWorksheet(workbook, sheet));

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportToExcel;